import { render, staticRenderFns } from "./consumerDetails.vue?vue&type=template&id=4ef5f8ad&scoped=true&"
import script from "./consumerDetails.vue?vue&type=script&lang=js&"
export * from "./consumerDetails.vue?vue&type=script&lang=js&"
import style0 from "./consumerDetails.vue?vue&type=style&index=0&id=4ef5f8ad&prod&scoped=true&lang=css&"
import style1 from "./consumerDetails.vue?vue&type=style&index=1&id=4ef5f8ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef5f8ad",
  null
  
)

export default component.exports